module.exports = __webpack_public_path__ + "static/img/training-icon-and-name.c3f89dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/training-icon-and-name.png
// module id = sR31
// module chunks = 0